<!-- 报表 采购退货单-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
          <el-form-item label="退货日期：">
            <el-date-picker v-model="searchForm.START_END" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" clearable :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单日期：">
            <el-date-picker v-model="searchForm.START_END_ORDER" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" clearable :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="供应商：">
            <el-select filterable v-model="searchForm.GYS" placeholder="请选择供应商" :clearable="true">
              <el-option v-for="item in companys" :key="item.SUPPLIER_ID" :label="item.AB_NAME" :value="item.SUPPLIER_ID"
                style="width: 200px"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.PRODUCT_NAME" clearable style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="btn" @click="handleSearch">筛选</el-button>
            <el-button type="primary" plain class="btn" @click="invoicesPrint" v-if="fun_dic[113050101]">结算单导出</el-button>
            <el-button @click="enterPurchaseReturnOrder" v-if="fun_dic[113050102]">录入采购退货单</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" fixed="left" :selectable="selectable"></el-table-column>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="订单编号" prop="ORDER_CODE" min-width="100px"></el-table-column>
          <el-table-column label="退货日期" prop="SEND_DAY" min-width="100px"></el-table-column>
          <el-table-column label="供应商名称" prop="AB_NAME" min-width="100px"></el-table-column>
          <el-table-column label="操作时间" prop="RETURN_TIME"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="openDetail(scope.row)" type="text">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { queryReturnProductFun, exportListHttp, invoicesPrint } from 'api/returnWare';
import { supplierList } from 'api/systemSetting';
import { getActionFun } from '@/assets/api/login';

export default {
  data() {
    return {
      PAGE_ID: '1130501',
      fun_dic: { 113050101: 0, 113050102: 0 },
      tableData: [],
      dialogVisible: false,
      inwareDate: [],
      name: '',
      pro_type: '',
      total_count: 0,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      form: {},
      pName: '',
      returnDialogVisible: false,
      region: '',
      deliverId: '',
      arr: [],
      searchForm: {},
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      companys: [],
      orderList: [],
      ORDER_ID_LIST: [],
    };
  },
  methods: {
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 导出
    exportList() {
      const params = {
      };
      if (this.searchForm.START_END) {
        params.START_DAY = this.searchForm.START_END[0];
        params.END_DAY = this.searchForm.START_END[1];
      }
      if (this.searchForm.START_END_ORDER) {
        params.ORDER_START_DAY = this.searchForm.START_END_ORDER[0];
        params.ORDER_END_DAY = this.searchForm.START_END_ORDER[1];
      }
      if (this.searchForm.GYS) {
        params.GYS = this.searchForm.GYS;
      }
      exportListHttp(params).then((res) => {
        window.location.href = res[0].FILE_PATH;
        this.$message.show({ text: '导出成功', type: 'success' });
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    posionFun() {
      this.pName = this.form.region;
    },
    // ------------------------拉取数据
    queryList() {
      const params = {
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.START_END) {
        params.START_DAY = this.searchForm.START_END[0];
        params.END_DAY = this.searchForm.START_END[1];
      }
      if (this.searchForm.START_END_ORDER) {
        params.ORDER_START_DAY = this.searchForm.START_END_ORDER[0];
        params.ORDER_END_DAY = this.searchForm.START_END_ORDER[1];
      }
      if (this.searchForm.GYS) {
        params.SUPPLIER_ID = this.searchForm.GYS;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      queryReturnProductFun(params).then((result) => {
        if (result.TOTAL_COUNT !== 0) {
          this.tableData = result.LIST;
          this.totalCount = result.TOTAL_COUNT;
          this.$store.dispatch('RETURNPRODUCT_ALL', {
            START_END: this.searchForm.START_END,
            START_END_ORDER: this.searchForm.START_END_ORDER,
            GYS: this.searchForm.GYS,
            PRODUCT_NAME: this.searchForm.PRODUCT_NAME,
          });
        } else {
          this.tableData = [];
          this.totalCount = result.TOTAL_COUNT;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryList();
    },
    openDetail(row) {
      this.$router.push({ path: '/returnProductDetail/detail' });
      sessionStorage.setItem('RETURN_ID', row.RETURN_ID);
      sessionStorage.setItem('returnMess', JSON.stringify(row));
      sessionStorage.setItem('where', 2);
    },
    handleSearch() {
      this.currentPage = 1;
      this.queryList();
    },
    queryGYSData() {
      const params = {
        PAGEINDEX: 0,
        PAGESIZE: 9999,
      };
      supplierList(params).then((result) => {
        if (result.length !== 0) {
          this.companys = result[0].list;
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 订单结算打印
    // 多选框
    selectable(row, index) {
      if (row.REAL_COUNT == 0) {
        return false;
      }
      return true;
    },
    handleSelectionChange(val) {
      this.ORDER_ID_LIST = val;
    },
    invoicesPrint() {
      if (this.ORDER_ID_LIST.length == 0) {
        this.$message.show({ text: '请先勾选订单', type: 'warning' });
        return false;
      }
      const params = {
        ORDER_ID_LIST: this.ORDER_ID_LIST.map((item) => item.RETURN_ID),
      };
      invoicesPrint(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    enterPurchaseReturnOrder() {
      this.$router.push({ name: 'enterPurchaseReturnOrder' });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.$set(this.searchForm, 'START_END', this.$store.state.RETURNPRODUCT_ALL.START_END);
    this.$set(this.searchForm, 'START_END_ORDER', this.$store.state.RETURNPRODUCT_ALL.START_END_ORDER);
    this.$set(this.searchForm, 'GYS', this.$store.state.RETURNPRODUCT_ALL.GYS);
    this.$set(this.searchForm, 'PRODUCT_NAME', this.$store.state.RETURNPRODUCT_ALL.PRODUCT_NAME);
    this.queryList();
    this.queryGYSData();
    this.queryBeforeFun();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableManage/returnProduct.vue